// ABOUTME: Configuration loader module for Hopp
// ABOUTME: Loads and provides access to config.json settings

let config = null;

export async function loadConfig() {
    if (config) return config;

    try {
        const response = await fetch('./config/config.json');
        if (!response.ok) {
            throw new Error(`Failed to load config: ${response.status}`);
        }
        config = await response.json();
    } catch (error) {
        console.error('Error loading configuration:', error);
        throw error;
    }

    return config;
}

export function getConfig() {
    if (!config) {
        throw new Error('Config not loaded. Call loadConfig() first.');
    }
    return config;
}

export function getMemorialConfig() {
    return getConfig().memorial;
}

export function getBrandingConfig() {
    return getConfig().branding;
}

export function getPennantsConfig() {
    return getConfig().pennants;
}

export function getPollingConfig() {
    return getConfig().polling;
}

export function getApiConfig() {
    return getConfig().api;
}

export function getInteractionConfig() {
    return getConfig().interaction;
}

export function getCandleConfig() {
    return getConfig().candles;
}

export function getCanvasConfig() {
    return getConfig().canvas;
}

export function getOnboardingConfig() {
    return getConfig().onboarding;
}

export function getPanIndicatorConfig() {
    return getConfig().panIndicator;
}

export function getPerformanceConfig() {
    return getConfig().performance;
}

export function getPaginationConfig() {
    return getConfig().pagination;
}

export function getRendererConfig() {
    return getConfig().renderer;
}

export function getGeometryConfig() {
    return getConfig().geometry;
}

export function getLoadingNotificationConfig() {
    return getConfig().loadingNotification;
}
